export const BREAKPOINT_SMALL = 576;
export const BREAKPOINT_MEDIUM = 768;
